import { ServerDevice } from '@/Devices/types';

export type ChipStatusType = 'default' | 'leak' | 'sensor' | 'connection';

interface ChipStatusProps {
  bgColor: string;
  color: string;
  type: ChipStatusType;
}

// order of severity for which device status is displayed in side drawer
export const STATUS_SEVERITY_RANK: Record<string, number> = {
  ERROR_CONNECTION: 1,
  ERROR_SENSOR: 2,
  ERROR_LEAK: 3,
  OKAY: 4,
  NO_DEVICES: 5,
};

// function to get the worst device based on status severity
export function getWorstDevice(devices: ServerDevice[]): ServerDevice | null {
  if (!devices || devices.length === 0) return null;

  return [...devices].sort((a, b) => {
    const aSeverity = STATUS_SEVERITY_RANK[a.device_status] ?? 99;
    const bSeverity = STATUS_SEVERITY_RANK[b.device_status] ?? 99;
    return aSeverity - bSeverity;
  })[0];
}

export function getChipStatusProps(
  deviceStatus: string,
  deviceStatusMessage?: string,
): ChipStatusProps | null {
  // Override based on status message
  if (deviceStatusMessage === 'Installation Check In Progress') {
    return {
      bgColor: '#E8F3EE',
      color: '#198754',
      type: 'default',
    };
  }

  switch (deviceStatus) {
    case 'ERROR_CONNECTION':
      return {
        bgColor: '#FCEBEC',
        color: '#DC3545',
        type: 'connection',
      };
    case 'ERROR_SENSOR':
      return {
        bgColor: '#FCEBEC',
        color: '#DC3545',
        type: 'sensor',
      };
    case 'ERROR_LEAK':
      return {
        bgColor: '#FFF9E6',
        color: '#6B5103',
        type: 'leak',
      };
    case 'OKAY':
      return {
        bgColor: '#E8F3EE',
        color: '#198754',
        type: 'default',
      };
    default:
      return null;
  }
}
